exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] ._3E5FKglOaK8r1DBvn8MLdm{padding-top:14px}._3E5FKglOaK8r1DBvn8MLdm .CYGsuA4JuT9bCOjTof2pl{font-size:17px;font-weight:300}html[dir] ._3E5FKglOaK8r1DBvn8MLdm .vU0gDEc66_y4E6wJBnQ7V{margin:8px 0 15px}html[dir] ._3E5FKglOaK8r1DBvn8MLdm ._3IjmxiRwMBScERP_leSoGd{margin-bottom:20px}html[dir=ltr] .oycu6PQLgesJBj6zqUuph{margin-left:8px}html[dir=rtl] .oycu6PQLgesJBj6zqUuph{margin-right:8px}", ""]);

// exports
exports.locals = {
	"calendarUpdatesWrapper": "_3E5FKglOaK8r1DBvn8MLdm",
	"sectionTitle": "CYGsuA4JuT9bCOjTof2pl",
	"sectionMessage": "vU0gDEc66_y4E6wJBnQ7V",
	"sectionCheckboxesMessage": "_3IjmxiRwMBScERP_leSoGd",
	"coloredBullet": "oycu6PQLgesJBj6zqUuph"
};